import { globalData } from "../..";
import { ID_NAMES } from "../../env";
import params from "../../params";
import { createSoundIcon } from "../messages/sounds";
import playerLinkDiv, { togglePlayerLink } from "./playerLinkDiv";

//MANIFEST CHECK IS USER ONLINE
const iframeManifestCheck = () => {

    const iframe = document.getElementById(ID_NAMES.IFRAME)
    const playerLink = document.getElementById(ID_NAMES.AFTER_PLAYER_CTA)
    const { pname } = globalData;

    if (iframe && playerLink && pname) {

        setInterval(() => {
            fetch(`https://manifest-server.naiadsystems.com/live/s:${pname}.json?last=timeout&format=mp4-hls`)
                .then(resp => {
                    if (playerLink) {
                        if (resp && resp.status !== 200) {
                            togglePlayerLink({ show: true })
                        } else {
                            togglePlayerLink({ show: false })
                        }
                    }
                })
        }, 2000)

    }

}

//SOUND OF IFRAME
const iframeSound = ({ src, muted }) => {

    let { origin, pathname, search } = new URL(src);

    const searchParams = new URLSearchParams(search);
    searchParams.delete('volumelevel')
    searchParams.delete('muted')

    if (!muted) {
        searchParams.set('muted', 0)
    } else {
        searchParams.set('muted', 1)
    }

    const url = `${origin}${pathname}?${searchParams.toString()}`

    return url

}

const createIframe = ({ div, contentDiv }) => {

    const { nosnd } = params()
    const { pname } = globalData;

    div.classList.add('chatheadMessageWithIframe');
    div.append(playerLinkDiv())

    const iframeSrc = iframeSound({
        src: `https://hybridclient.naiadsystems.com/purecam?widescreen=true&performer=${pname}`,
        muted: nosnd || false
    })

    //OUTLINK IS ON THE PLAYLINK
    contentDiv.innerHTML = `
        <div class="chatheadMessageIframePlaceholder">
            <svg viewBox="0 0 259 220" xmlns="http://www.w3.org/2000/svg" class="svgPlaceholder">
                <rect width="259" height="220" />
            </svg>
        </div>
        <iframe id="${ID_NAMES.IFRAME}" title="Jerkmate live!" frameborder="0" allow="autoplay" scrolling="no" src="${iframeSrc}">
        </iframe>
    `

    contentDiv.append(createSoundIcon())


}

export { createIframe, iframeSound, iframeManifestCheck }